module.exports = __webpack_public_path__ + "static/media/visa.acf28b60.svg";